// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2u7Cp","buttons":"Footer_buttons__1uVjU"};